import { useMemo, useState } from 'react';
import { StoreInfoValue } from '@headless-workspace/domain/common/server';
import { ArrayHelpers, ObjectHelpers } from '@headless-workspace/utils';
import { splitByStoreCategory } from './splitByStoreCategory';

export const useStoresDisplay = ({
    stores,
    productSku,
    favoriteStoreId,
    highlightedStoreId,
}: {
    stores: StoreInfoValue[];
    productSku: string;
    favoriteStoreId?: string;
    highlightedStoreId?: string;
}) => {
    const [isMoreStoresVisible, setIsMoreStoresVisible] = useState(false);

    const { availableStock, unavailableStock, highlightedStore, favoriteStore, unavailableLength } = useMemo(
        () => splitByStoreCategory(stores, productSku, favoriteStoreId, highlightedStoreId),
        [favoriteStoreId, highlightedStoreId, productSku, stores],
    );

    const shouldDisplayMoreStoresButton = useMemo(() => {
        return (
            !isMoreStoresVisible && ArrayHelpers.isNotEmpty(unavailableStock) && ArrayHelpers.isNotEmpty(availableStock)
        );
    }, [isMoreStoresVisible, unavailableStock, availableStock]);

    return {
        stores: [
            highlightedStore,
            favoriteStore,
            ...availableStock,
            ...(isMoreStoresVisible || !shouldDisplayMoreStoresButton ? unavailableStock : []),
        ].filter(ObjectHelpers.isNotNullishGuard<StoreInfoValue>),
        displayMoreStoresVisibleButton: shouldDisplayMoreStoresButton,
        setIsMoreStoresVisible,
        noStoresWithStockAvailable: !ArrayHelpers.isNotEmpty(availableStock) && unavailableLength !== 0,
    };
};
